module.exports = __webpack_public_path__ + "static/media/41-12.e33b3b0c.mp3";